import {
  MantineTheme,
  AlertProps,
  PartialVarsResolver,
  AlertFactory
} from '@mantine/core';

export const AlertVarsResolver: PartialVarsResolver<AlertFactory> = (
  theme: MantineTheme,
  props: AlertProps
) => {
  if (props.color === 'primary') {
    return {
      root: {
        '--alert-bg': '#EBF5FF',
        '--alert-color': 'var(--mantine-color-primary-4)'
      },
      message: {
        color: 'var(--alert-color)'
      }
    };
  } else if (props.color === 'success') {
    return {
      root: {
        '--alert-bg': 'var(--mantine-color-success-1)',
        '--alert-color': '#218358'
      },
      message: {
        color: 'var(--alert-color)'
      }
    };
  }
  // todo : handle other colors as per design system

  return {
    root: {}
  };
};

export const DefaultAlertProps: Partial<AlertProps> = {
  radius: 'xs'
  // variant: 'light'
};
